import { ResponsibleConsumption } from "@faire/web--source/slate/icons/foundation/ResponsibleConsumption";
import { ShareHeart } from "@faire/web--source/slate/icons/foundation/ShareHeart";
import { Sprout } from "@faire/web--source/slate/icons/foundation/Sprout";
import { SVGIcon } from "@faire/web--source/slate/icons/SVGIcon";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import { IIconTextListItem } from "@faire/web-api--source/indigofair/data/IIconTextListItem";
import React from "react";

interface IProps extends SVGIcon.IProps {
  name?:
    | keyof typeof IIconTextListItem.SlateIcon
    | keyof typeof IFaireIcon.Type;
}

export const StyledIconByName: React.FC<IProps> = ({
  name,
  fontSize,
  color,
  strokeWidth,
}) => {
  if (!name) {
    return null;
  }

  /**
   * NOTE:
   * This is not an optimal way to map icons with enum,
   * when icons mapped in this file grow to a big scale,
   * we should consider introduce a lazy icon component at Slate to avoid large bundles
   */
  switch (name) {
    case IFaireIcon.Type.SPROUT:
      return (
        <Sprout color={color} fontSize={fontSize} strokeWidth={strokeWidth} />
      );
    case IFaireIcon.Type.SHARE_HEART:
      return (
        <ShareHeart
          color={color}
          fontSize={fontSize}
          strokeWidth={strokeWidth}
        />
      );
    case IFaireIcon.Type.RESPONSIBLE_CONSUMPTION_AND_PRODUCTION:
      return (
        <ResponsibleConsumption
          color={color}
          fontSize={fontSize}
          strokeWidth={strokeWidth}
        />
      );
    default:
      return null;
  }
};
